
import { defineComponent, PropType } from "@vue/runtime-core";
import Multiselect from "@/Components/General/Multiselect.vue";
import { RfpCategory } from "@/types/Rfp/RfpCategory";

export default defineComponent({
  props: {
    modelValue: {
      type: Object as PropType<number[]>,
      default: () => null,
    },
    categories: {
      type: Object as PropType<RfpCategory[]>,
      default: () => [],
    },
  },
  emits: ["update:modelValue"],
  components: {
    Multiselect,
  },
  computed: {
    value: {
      get(): number[] {
        return this.modelValue;
      },
      set(v: number[]) {
        this.$emit("update:modelValue", v);
      },
    },
    options(): object[] {
      return this.categories.map((category: RfpCategory): object => {
        category.label = category.title;
        return category;
      });
    },
  },
});
